module.exports = __webpack_public_path__ + "img/template-selelct-float.6586b5f1.png";